import lo1 from "../../assets/images/logo-company/cty11.png";
import lo2 from "../../assets/images/logo-company/cty9.png";
import lo3 from "../../assets/images/logo-company/cty7.png";
import lo4 from "../../assets/images/logo-company/cty6.png";
import lo5 from "../../assets/images/logo-company/cty15.png";
import lo6 from "../../assets/images/logo-company/cty16.png";
import avt1 from "../images/cadidate/user1.png";
import avt2 from "../images/cadidate/user2.png";
import avt3 from "../images/cadidate/user3.png";
import avt4 from "../images/cadidate/user4.png";
import avt5 from "../images/cadidate/user5.png";
import avt6 from "../images/cadidate/user6.png";

const marKers = [
  {
    id: 1,
    title: "TOP Agency, Inc",
    name: "Full Stack Development",
    address: "Las Vegas, NV 89107, USA",
    longitude: -74.006821,
    latitude: 40.706755,
    img: lo1,
  },
  {
    id: 2,
    title: "TOP Agency, Inc",
    name: "Full Stack Development",
    address: "Las Vegas, NV 89107, USA",
    longitude: -74.00423,
    latitude: 40.705445,
    img: lo2,
  },
  {
    id: 3,
    title: "TOP Agency, Inc",
    name: "Senior UI/UX Designer",
    address: "Las Vegas, NV 89107, USA",
    longitude: -74.009766,
    latitude: 40.703859,
    img: lo3,
  },
  {
    id: 4,
    title: "TOP Agency, Inc",
    name: "Full Stack Development",
    address: "Las Vegas, NV 89107, USA",
    longitude: -74.014434,
    latitude: 40.706828,
    img: lo4,
  },
  {
    id: 5,
    title: "TOP Agency, Inc",
    name: "Senior DevOps Engineer",
    address: "Las Vegas, NV 89107, USA",
    longitude: -74.012139,
    latitude: 40.709024,
    img: lo5,
  },
  {
    id: 6,
    title: "TOP Agency, Inc",
    name: "Social Media Marketing",
    address: "Las Vegas, NV 89107, USA",
    longitude: -73.992613,
    latitude: 40.704015,
    img: lo6,
  },
  {
    id: 7,
    title: "Chief Executive Officer",
    name: "Cody Fisher",
    address: "Tokyo, Japan",
    longitude: -74.006821,
    latitude: 40.706755,
    img: avt1,
    cate: "Available now",
  },
  {
    id: 8,
    title: "Computational Wizard",
    name: "Arlene McCoy",
    address: "New York",
    longitude: -74.00423,
    latitude: 40.705445,
    img: avt2,
    cate: "Available now",
  },
  {
    id: 9,
    title: "QA Tester",
    name: "Floyd Miles",
    address: "Tokyo, Japan",
    longitude: -74.009766,
    latitude: 40.703859,
    img: avt4,
    cate: "Available now",
  },
  {
    id: 10,
    title: "Digital Overlord",
    name: "Annette Black",
    address: "Tokyo, Japan",
    longitude: -74.014434,
    latitude: 40.706828,
    img: avt5,
    cate: "Available now",
  },
  {
    id: 11,
    title: "Sales Engineer",
    name: "Kathryn Murphy",
    address: "Tokyo, Japan",
    longitude: -74.012139,
    latitude: 40.709024,
    img: avt6,
    cate: "Available now",
  },
  {
    id: 12,
    title: "Database Administrator",
    name: "Guy Hawkins",
    address: "Tokyo, Japan",
    longitude: -73.992613,
    latitude: 40.704015,
    img: avt3,
    cate: "Available now",
  },
];

export default marKers;
